// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import App from './App'
import store from './store'
import router from './router'

// vxe-table插件引入
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

// 右键菜单插件
import VueContentMenu from 'vue-contextmenu'

// 公共css引入
import './assets/css/seller-layoutContent.min.css'
import './assets/css/seller-platform.min.css'
import './assets/css/seller-button.min.css'
import './assets/css/seller-dialog.min.css'
import './assets/css/seller-input-style.min.css'
import './assets/css/seller-table.min.css'
import './assets/css/seller-tab.min.css'
import './assets/css/seller-model-style.min.css'
import './assets/css/seller-detail.min.css'
import './assets/css/seller-errorPage.min.css'

Vue.use(ElementUI)
Vue.use(VueContentMenu)
Vue.use(VXETable)
VXETable.setup({})

Vue.config.productionTip = false

/* eslint-disable no-new */
const mainVue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

// 创建一个空的vue实例，用于传输数据
Vue.prototype.bus = new Vue()

// 定义"回到顶部"功能
Vue.prototype.$scrollTo = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth' // 滚动行为：smooth平滑滚动，instant瞬间滚动，默认值auto，等同于instant
  })
}

// 将vue实例返回出去，给需要调用的js使用
export default mainVue



// WEBPACK FOOTER //
// ./src/main.js